import { useState } from "react";
import "./styles/cis.css";
import InternalError from "../components/generales/InternalError";
import { lang } from '../components/generales/traduction'
import PanelProvInfo from "../components/provicionamiento-componentes/PanelProvInfo";
// import PanelCalendario from "../components/excepciones-components/PanelCalendario";
// import PanelExcepciones from "../components/excepciones-components/PanelExcepciones";
import PanelProvisionamiento from "../components/provicionamiento-componentes/PanelProvisionamiento"; 
import PanelProvSoft from "../components/provicionamiento-componentes/PanelProvSoft";
import PanelProvCalendario from "../components/provicionamiento-componentes/PanelProvCalendario";
import PanelAuditor from "../components/provicionamiento-componentes/PanelAuditor";
const Provisionamiento = ({handleShowPopup,pageSelected, server, dataGlobals,languaje,mode }) => {
    const [listSelected, setListSelected] = useState(1);
    const [internalError,setInternalError]=useState(false)
    const hadleChangeList = (e) => {
      setListSelected(e);
    };
    const [cisSelected, setCisSelected] = useState([]);
    function renderAdminComponent() {
        try {
            switch (pageSelected) {
                case "provicionamiento-config":
                    return (cisSelected.length==0)?
                    <PanelProvisionamiento mode={mode} languaje={languaje} server={server}
                    handleShowPopup={handleShowPopup}
                    cisSelected={cisSelected} 
                    setCisSelected={setCisSelected}
                    />:
                    <PanelProvInfo mode={mode} languaje={languaje} server={server}
                    handleShowPopup={handleShowPopup}
                    cisSelected={cisSelected} 
                    setCisSelected={setCisSelected}
                    />;
                case "provicionamiento-soft":
                    return <PanelProvSoft handleShowPopup={handleShowPopup} languaje={languaje} mode={mode}  server={server}  setInternalError={setInternalError}/>;
                case "provicionamiento-calendario":
                    return <PanelProvCalendario handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server} setInternalError={setInternalError}/>;
                case "provicionamiento-auditor":
                    return <PanelAuditor handleShowPopup={handleShowPopup} languaje={languaje} mode={mode} server={server} setInternalError={setInternalError}/>;
                default:
                    return <></>;
            }
        } catch (error) {
            console.error('Error rendering component:', error);
            return <div>{lang[languaje['msgErrorPagina']]}</div>;
        }
    }
    return (
      <div className={"main-cis"+mode}>
         
      { renderAdminComponent()}
             
                      {/* {(cisSelected.length==0)?
                      <PanelProvisionamiento mode={mode} languaje={languaje} server={server}
                      handleShowPopup={handleShowPopup}
                      cisSelected={cisSelected} 
                      setCisSelected={setCisSelected}
                      />:
                      <PanelProvInfo mode={mode} languaje={languaje} server={server}
                      handleShowPopup={handleShowPopup}
                      cisSelected={cisSelected} 
                      setCisSelected={setCisSelected}
                      />
                     
                      } */}
                  
        
       </div>
    );
};

export default Provisionamiento;
